






























import Vue from 'vue';
import { NoExpression } from 'expangine-runtime';
import { editMethodDialog, PREF_FULLSCREEN_EDIT_METHOD } from './EditMethod';
import { Preferences } from './Preference';



export default Vue.extend({
  data: () => editMethodDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    disableSave(): boolean {
      return this.method.expression === NoExpression.instance;
    },
    isSaved(): boolean {
      return this.entity.methods[this.method.name] === this.method;
    },
    buttonText(): string {
      return this.isSaved ? 'Close' : 'Cancel';
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_EDIT_METHOD, this.fullscreen);
    },
  },
});
